<template>
  <section>
    <overlay-alert
      :show-progress="showProgress"
      :process-alert="processAlert"
    />
    <br>
    <p class="p-style">
      Step 1: Location Verification
    </p>
    <p
      v-if="verificationFailed"
      class="fail-message-style"
    >
      <font>
        <v-icon
          size="30"
          color="#C62828"
        >
          mdi-close-thick
        </v-icon>
        {{ verificationFailedMessage }}
      </font>
    </p>
    <v-card
      class="card-style"
      color="#ECEFF1"
      :style="getBgStyle"
    >
      <v-card-text class="justify-center">
        <v-container fluid>
          <div class="user-div">
            <p class="user-content">
              Name:- <font class="font-my-style">
                {{ userDetails.service_provider.first_name }} {{ userDetails.service_provider.last_name }}
              </font>
            </p>
            <p class="user-content">
              Mobile:- <font class="font-my-style">
                {{ userDetails.service_provider.phone_number }}
              </font>
            </p>
            <p class="user-content">
              Company:- <font class="font-my-style">
                {{ userDetails.service_provider.company.company_name }}
              </font>
            </p>
            <p class="user-content">
              Category:- <font
                v-if="userDetails.service_provider.contractor_category !== null"
                class="font-my-style"
              >
                {{ userDetails.service_provider.contractor_category.name }}
              </font>
              <font v-else>
                N/A
              </font>
            </p>
            <p class="user-content">
              Check-In Types:-<font
                class="font-my-style"
              >
                {{ userDetails.service_provider.type | arrangePretty }}
              </font>
            </p>
          </div>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="#37474F"
              @click="cancel()"
            >
              Cancel
            </v-btn>
            <v-btn
              color="#FF3700"
              :light="locationFetchFailed"
              :disabled="locationFetchFailed"
              @click="verifyLocation()"
            >
              Next
            </v-btn>
            <v-spacer />
          </v-card-actions>
        </v-container>
      </v-card-text>
    </v-card>
    <br>
    <centre-spinner
      :loading="loading"
    />
    <browser-loc-permission-setting
      v-if="showBrowserLocSettingsForm"
      :error-message="verificationFailedMessage"
      @closed="showBrowserLocSettingsForm = false"
    />
  </section>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
import OverlayAlert from 'src/views/components/OverlayAlert';
import BrowserLocPermissionSettings from '../../../BrowserLocPermissionSettings.vue';

export default {
  name: 'VisitorLocVerification',
  components: {
    'centre-spinner': spinner,
    'overlay-alert': OverlayAlert,
    'browser-loc-permission-setting': BrowserLocPermissionSettings,
  },
  filters: {
    arrangePretty (val) {
      return val.join(', ');
    },
  },
  data: () => ({
    loading: false,
    cardBgImg: require('@/assets/img/cardBg.png'),
    verificationFailed: false,
    verificationFailedMessage: '',
    showProgress: false,
    processAlert: '',
    latitudeValue: null,
    longitudeValue: null,
    locationFetchFailed: false,
    showBrowserLocSettingsForm: false,
  }),
  computed: {
    getBgStyle () {
      return `background-image: linear-gradient(rgba(255,255,255,.6), rgba(255,255,255,.6)), url(${this.cardBgImg});`;
    },
    userDetails () {
      return this.$store.getters.getUser;
    },
  },
  mounted () {
    this.fetchLocationDetails();
  },
  methods: {
    fetchLocationDetails () {
      if (navigator.geolocation) {
        this.showProgress = true;
        this.processAlert = 'Checking Out...';
        navigator.geolocation.getCurrentPosition(this.showPosition, this.showError);
      } else {
        this.showProgress = false;
        this.verificationFailed = true;
        this.verificationFailedMessage = 'Geolocation is not supported by this browser.';
      }
    },
    showPosition (position) {
      this.latitudeValue = position.coords.latitude;
      this.longitudeValue = position.coords.longitude;
      this.showProgress = false;
    },
    showError (error) {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          this.showProgress = false;
          this.locationFetchFailed = true;
          this.verificationFailed = true;
          this.verificationFailedMessage = 'User denied the request for location access. Please close the tab and relaunch our app once access is enabled.';
          this.showBrowserLocSettingsForm = true;
        break;
        case error.POSITION_UNAVAILABLE:
          this.showProgress = false;
          this.locationFetchFailed = true;
          this.verificationFailed = true;
          this.verificationFailedMessage = 'Location information is unavailable.';
        break;
        case error.TIMEOUT:
          this.showProgress = false;
          this.locationFetchFailed = true;
          this.verificationFailed = true;
          this.verificationFailedMessage = 'The request to get user location timed out.';
        break;
        case error.UNKNOWN_ERROR:
          this.showProgress = false;
          this.locationFetchFailed = true;
          this.verificationFailed = true;
          this.verificationFailedMessage = 'An unknown error occurred.';
        break;
      }
    },
    verifyLocation () {
      this.loading = true;
      this.$store.dispatch('swiftuser/clearScannedLocationName');
      const siteId = this.$route.params.siteId;
      this.$store.dispatch('swiftuser/verifyLocation', {
        site_id: siteId,
        checkin_latitude: this.latitudeValue.toString(),
        checkin_longitude: this.longitudeValue.toString(),
        checkin_type: 'check-out',
      }).then(response => {
        this.loading = false;
        this.$emit('verification-completed');
      }).catch(error => {
        this.loading = false;
        this.verificationFailed = true;
        this.verificationFailedMessage = error.response.data.message;
        setTimeout(() => {
          this.$emit('verification-completed');
        }, 5000);
      });
    },
    cancel () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'HomePage' });
      }, 2000);
    },
  },
};
</script>
<style scoped>
.p-style {
  margin-left: 10px;
  color: #37474F;
  font-weight: bold;
  font-family: 'Times New Roman', Times, serif;
  font-size: 18px;
}
.card-style {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 5px;
  margin-right: 5px;
  padding-top: 25px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.user-content {
  font-size: 16px;
  font-weight: bold;
  margin-left: 10px;
  color: #546E7A;
  font-family:'Times New Roman', Times, serif;
}
.font-my-style {
  font-weight: bold;
  font-size: 15px;
  color: #37474F;
  font-family:'Times New Roman', Times, serif;
  text-transform: capitalize;
}
.user-div {
  line-height:normal;
  border-left: 3px solid #FF3700;
  margin-bottom: 40px;
  margin-top: 20px;
}
.fail-message-style {
  font-size: 18px;
  font-weight: bold;
  color: #C62828;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  text-align: center;
}
</style>
